import ApplePaySVG from 'app/assets/icons/footer/apple-pay.svg'
import GooglePaySVG from 'app/assets/icons/footer/google-pay.svg'
import MastercardSVG from 'app/assets/icons/footer/mastercard.svg'
import PayPalSVG from 'app/assets/icons/footer/paypal.svg'
import VisaSVG from 'app/assets/icons/footer/visa.svg'
import fbhvcLogoImage from 'app/assets/images/fbhvc-logo.png'
import hcvaMemberImage from 'app/assets/images/hcva-member.png'
import Box from 'app/components/base/Box'
import Image from 'app/components/base/Image'
import Stack from 'app/components/base/Stack'
import { getStaticImageSrc } from 'app/utils/helpers/functions.helpers'

const PaymentsAndMembers = () => {
  const hcvaMemberImageSrc = getStaticImageSrc(hcvaMemberImage)
  const fbhvcLogoImageSrc = getStaticImageSrc(fbhvcLogoImage)

  return (
    <Stack direction="column" spacing={3}>
      <Stack direction="row" spacing={1}>
        <VisaSVG />

        <MastercardSVG />

        <PayPalSVG />

        <GooglePaySVG />

        <ApplePaySVG />
      </Stack>

      <Stack direction="row" spacing={2}>
        <Box sx={{ width: 72, height: 72 }}>
          <Image
            src={hcvaMemberImageSrc}
            width={72}
            height={72}
            sizes="128px"
            alt="hcva-member"
            placeholder="blur"
            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mMUEHaQAQABHwCBJOqiVAAAAABJRU5ErkJggg=="
          />
        </Box>

        <Box sx={{ width: 100, height: 72 }}>
          <Image
            src={fbhvcLogoImageSrc}
            width={100}
            height={72}
            sizes="256px"
            alt="fbhvc-logo"
            placeholder="blur"
            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mMUEHaQAQABHwCBJOqiVAAAAABJRU5ErkJggg=="
          />
        </Box>
      </Stack>
    </Stack>
  )
}

export default PaymentsAndMembers
